/* Moved verbatim out of sections/gift-builder.liquid (2026-10-05) to keep the section under Shopify's 256 KB cap. Loaded synchronously at the same position. */
/* BEGIN gb-mobile-fix-2026-05-31 - single rotating review testimonial (mobile) */
(function () {
  function initReviewQuoteRotator() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var grid = document.querySelector('#gb-step-4 .gb-review-proof-grid');
    if (!grid || grid.dataset.ssRotating === '1') return;
    var cards = grid.querySelectorAll('.gb-review-proof-card');
    if (cards.length < 2) return;
    grid.dataset.ssRotating = '1';
    grid.classList.add('gb-proof-rotating');
    var i = 0;
    cards[i].classList.add('is-shown');
    setInterval(function () {
      cards[i].classList.remove('is-shown');
      i = (i + 1) % cards.length;
      cards[i].classList.add('is-shown');
    }, 2000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewQuoteRotator);
  } else {
    initReviewQuoteRotator();
  }
})();
/* END gb-mobile-fix-2026-05-31 */
